module.exports = __webpack_public_path__ + "static/Aws-072d9851bb41b4abc655be5d7450c051.png";